import * as yup from 'yup';

// Schémas de validation Yup
const partnerChangeValidationSchema = yup.object().shape({
    change: yup.string().required('Veuillez indiquer le type de modification')
});

export default partnerChangeValidationSchema